// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types'
import styled from 'styled-components';
import throttle from 'lodash/throttle';
import Icon from '../icon/Icon';
import { ICONS } from '../icon/Icons';

const StyledSelectWrapper = styled.div`
  display: flex;
  align-items: center;
  border-radius: 2px;
  margin-bottom: 1rem;
  position: relative;
  color: #4a4a4a;
  background: white;
  border: 1px solid #CED5D8;
  box-shadow: 0 1px 5px 0 rgba(155,155,155,0.37);

  &.touched {
    color: inherit;
  }

  i {
    right: 1px;
    display: inline-block;
    width: 35px;
    text-align: center;
    position: relative;
    background: -webkit-linear-gradient(left, rgba(255,255,255,0) 0%,rgba(255,255,255,0) 1%,rgba(255,255,255,1) 30%,rgba(255,255,255,1) 100%);
    background: linear-gradient(to right, rgba(255,255,255,0) 0%,rgba(255,255,255,0) 1%,rgba(255,255,255,1) 30%,rgba(255,255,255,1) 100%);
    pointer-events: none;
    // z-index: 0;
    // position: absolute;
    // right: 0;
  }
`;

const StyledSelect = styled.select`
  width: 100%;
  margin-right: -36px;
  background: transparent;
  flex: 1 0;
  font-family: inherit !important;
  font-size: 1rem;
  line-height: 1em;
  appearance: none;
  padding: 0.875rem 0 0.875rem 0.875rem;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  //z-index: 1;
  color: inherit;
  text-overflow: ellipsis;
  & option{
    width:100%;
    text-overflow:ellipsis;
    overflow:hidden;
  }
`;

class Select extends Component {
  static propTypes = {
    children: PropTypes.node
  }

  onClick = throttle((event) => {
    if (event.type !== 'touchstart') {
      event.preventDefault();
    }
  }, 100, { leading: true, trailing: false })

  render() {
    const { children, tabIndex, className, ...restProps } = this.props;
    return (
      <div tabIndex={tabIndex}>
        <StyledSelectWrapper className={className}>
          <StyledSelect {...restProps}>
            {children}
          </StyledSelect>
          <i>
            <Icon
              icon={ICONS.ARROW_DOWN}
              // fill={colors.BRAND_GREEN}
              fill='#4A4A4A'
              width={`${13/16}rem`}
              height={`${13/16}rem`}
            />
          </i>
        </StyledSelectWrapper>
        {/*{errors && errors.map((error, i) => {
          return (
            <p key={i}>{error}</p>
          );
        })}*/}
      </div>
    );
  }
}

export default Select;



// WEBPACK FOOTER //
// ./src/modules/common/components/select/Select.js